<template>
  <section class="account-create-area">
    <div class="container">
      <div class="account-create-content">
        <h2>Apply for an account in minutes</h2>
        <p>Get your IRechargePay account today!</p>
        <a target="_blank" href="https://irecharge.com.ng/#/irecharge_merchant" class="btn btn-primary">
          Become A Merchant Today
        </a>
      </div>
    </div>
  </section>
</template>

<script>
export default {};
</script>

<style scoped>
</style>